import { useEffect } from "react";
import { useGeolocationStore } from "@/common/store/geolocationStore";
import { apiGeo } from "@/common/services";
import { useLocation } from "react-router-dom";

export const useDetectGeolocation = () => {
  const { pathname } = useLocation();
  const location = useGeolocationStore((state) => state.location);
  const setLocation = useGeolocationStore((state) => state.setLocation);

  useEffect(() => {
    if (location || pathname.startsWith("/ifr")) {
      return;
    }

    (async () => {
      const location = await apiGeo.getGeolocation();

      setLocation(location);
    })();
  }, [pathname]);
};
